import cx from 'classnames'
import Styles from './RadioGroup.module.scss'
import { RadioBulletProps } from './Types'
import { CSSProperties } from 'react'

export const RadioBullet = ({
  isSelected = false,
  isFocusVisible = false,
  isDisabled = false,
  rightAligned = false,
  size = 16,
}: RadioBulletProps) => (
  <div
    className={cx(Styles.radioButton, {
      [Styles.selected]: isSelected,
      [Styles.focused]: isFocusVisible,
      [Styles.disabled]: isDisabled,
      [Styles.rightAligned]: rightAligned,
    })}
    style={
      {
        width: `${size}px`,
        height: `${size}px`,
        '--radio-size': `${size}px`,
      } as CSSProperties
    }
  />
)
